import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const FeatureCards = () => {
  const { language } = useLanguage();
  const t = translations[language].featureCards;

  const cards = [
    {
      title: t.offRoadVehicle,
      image: '/assets/images/homepage/feature-cards/OFF-ROAD VEHICLE.jpg',
      link: '/history/off-road',
    },
    {
      title: t.baicHistory,
      image: '/assets/images/homepage/feature-cards/Baic History.jpg',
      link: '/history/baic',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {cards.map((card, index) => (
            <a
              key={index}
              href={card.link}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
            >
              <div className="aspect-[6/4] relative">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-white text-xl font-bold mb-2 group-hover:text-red-400 transition-colors">
                    {card.title}
                  </h3>
                  <div className="flex items-center text-white/80 group-hover:text-white transition-colors">
                    <span className="text-sm">{t.learnMore}</span>
                    <ArrowRight className="mx-2 h-4 w-4 transform group-hover:translate-x-2 transition-transform" />
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureCards;